import { Check } from "lucide-react";

export default function PortalProgress({ quotes, bookings, docs }) {
  const steps = [
    { key: "quote", label: "Quote", done: quotes.length > 0 },
    { key: "deposit", label: "Deposit", done: quotes.some((q) => q.deposit_paid) },
    { key: "documents", label: "Documents", done: docs.length > 0 },
    { key: "consultation", label: "Consultation", done: bookings.some((b) => b.status === "confirmed") || bookings.length > 0 },
    { key: "move", label: "Move day", done: quotes.some((q) => q.status === "completed") },
  ];
  const currentIdx = steps.findIndex((s) => !s.done);

  return (
    <div data-testid="portal-progress" className="rounded-2xl border border-sand-200 bg-white p-5 sm:p-6">
      <h2 className="text-sm uppercase tracking-[0.15em] text-clay-700 font-medium mb-5">Your move progress</h2>
      <ol className="flex items-start">
        {steps.map((s, i) => (
          <li key={s.key} className="flex-1 flex flex-col items-center relative" data-testid={`progress-step-${s.key}`}>
            {i > 0 && (
              <span
                className={`absolute top-4 right-1/2 w-full h-0.5 -translate-y-1/2 ${steps[i - 1].done ? "bg-sage" : "bg-sand-200"}`}
                aria-hidden="true"
              />
            )}
            <span
              className={`relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 text-xs font-semibold transition-colors ${
                s.done
                  ? "bg-sage border-sage text-white"
                  : i === currentIdx
                    ? "bg-white border-terracotta text-terracotta"
                    : "bg-white border-sand-200 text-charcoal-400"
              }`}
            >
              {s.done ? <Check size={15} strokeWidth={3} /> : i + 1}
            </span>
            <span className={`mt-2 text-[11px] sm:text-xs text-center leading-tight ${s.done ? "text-sage font-medium" : i === currentIdx ? "text-terracotta font-medium" : "text-charcoal-400"}`}>
              {s.label}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
